import { render, staticRenderFns } from "./LeadCard.vue?vue&type=template&id=6d8a53a8"
import script from "./LeadCard.vue?vue&type=script&lang=ts"
export * from "./LeadCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports